/**
 * Multiplier curve shared by server (authoritative) and client (display).
 *   m(t) = e^(k·t)   with t in ms since `startedAt`.
 * Display values are floored to 2 decimals so both sides agree bit-for-bit.
 */
/** Floor to 2 decimals without binary-float surprises (1.005 → 1.00, 2.3 → 2.30). */
export function floor2(value) {
    return Math.floor(value * 100 + 1e-9) / 100;
}
/** Raw (unrounded) multiplier at `elapsedMs`. Never below 1. */
export function multiplierRaw(elapsedMs, k) {
    if (elapsedMs <= 0)
        return 1;
    return Math.exp(k * elapsedMs);
}
/** Display multiplier (2 decimals, floored) at `elapsedMs`. */
export function multiplierAt(elapsedMs, k) {
    return Math.max(1, floor2(multiplierRaw(elapsedMs, k)));
}
/** Time in ms needed to reach `multiplier` (inverse of multiplierRaw). */
export function elapsedForMultiplier(multiplier, k) {
    if (multiplier <= 1)
        return 0;
    return Math.log(multiplier) / k;
}
/**
 * Server-side cashout evaluation.
 * @returns the payout multiplier, or null if the round already crashed at `receivedAt`.
 */
export function evaluateCashout(args) {
    const tolerance = args.toleranceMs ?? 0;
    const elapsed = Math.max(0, args.receivedAt - args.startedAt - tolerance);
    const m = multiplierAt(elapsed, args.k);
    return m < args.crashAt ? m : null;
}
/** Payout for a bet, floored to `decimals` (currency precision). */
export function payout(amount, multiplier, decimals = 2) {
    const f = 10 ** decimals;
    return Math.floor(amount * multiplier * f + 1e-9) / f;
}
//# sourceMappingURL=multiplier.js.map